<template>
	<section :class="contStyle">
		<div class="cont169">
			<div class="imageCont" v-if="previewType=='image'">
				<router-link :to="linkToDetail">
					<intersect @enter="msg = 'Intersected'" @leave="msg = 'Not intersected'">
						<img :src="youtubeThumb" class="youtubeThumb" :alt="imgYTalt" />
					</intersect>
				</router-link>
			</div>
			<div v-if="previewType=='video'">
				<iframe width="560" height="315" :src="youtubeEmbedIframeUrl" frameborder="0" allowfullscreen v-if="online"></iframe>
				<div class="imageCont" v-if="!online">
					<img :src="youtubeThumb" class="youtubeThumb" :alt="imgYTalt" />
				</div>
			</div>
		</div>
		<div class="voteCont" v-if="vote">
			<div v-if="online">
				<span v-if="previewType=='video'" :aria-label="votesLabel">
					{{votes}}
				</span>
				<button class="voteUp" @click="voteUp" aria-label="vota a favore"><i class="gdr-icon gdr-icon-thumbs-up"></i><!-- vote up --></button>
				<button class="voteDown" @click="voteDown" aria-label="vota contro"><i class="gdr-icon gdr-icon-thumbs-down"></i><!-- vote down --></button>
			</div>
			<div v-if="!online">
				Sei offline, non puoi vedere il video o votare
			</div>
		</div>
	</section>
</template>
<script>
	import Intersect from '../lib/vue-interaction-observer'
	import youtubeLinks from '../lib/youtubeLinks'

	export default {
		name: 'videoplayer',
		data () {
			return {
				msg: '',
			}
		},
		props:{
			videoID:{
				default:''
			},
			previewType:{
				default:'video'
			},
			shadow:{
				default:true
			},
			vote:{
				default:true
			},
			detail:{
				default:false
			}
		},
		computed:{
			imgYTalt: function(){
				if(this.videoID){
					return "immagine per il video su youtube all'indirizzo https://www.youtube.com/watch?v=" + this.videoID;
				}
				return '';
			},
			youtubeThumb: function () {
				if(this.msg=="Intersected"){
					if(this.videoID){
						return youtubeLinks.youtubeThumbUrl(this.videoID)
						// return 'https://img.youtube.com/vi/' + this.videoID + '/hqdefault.jpg'
					}
				}
				return '';
			},
			linkToDetail: function (){
				if(this.videoID){
					return '/detail/' + this.videoID
				}
				return '';
			},
			youtubeEmbedIframeUrl: function (){
				if(this.videoID){
					return youtubeLinks.youtubeEmbedIframeUrl(this.videoID);
					// return 'https://www.youtube-nocookie.com/embed/' + this.videoID + '?rel=0&amp;showinfo=0'
				}
				return '';
			},
			votes: function(){
				return this.$root.votes;
			},
			votesLabel: function(){
				if(this.videoID){
					return this.votes + " voti per il video su youtube all'indirizzo https://www.youtube.com/watch?v=" + this.videoID;
				}
			},
			contStyle: function(){
				var style = "videoPlayer gdr-card";
				if(this.shadow){
					style = style + " shadow"
				}else{

				}
				return style;
			},
			online: function(){
				if(navigator.onLine){
					return true
				}else{
					return false
				}
			}
		},
		methods:{
			voteUp: function() {
				this.$root.voteUp(this.videoID);
			},
			voteDown: function() {
				this.$root.voteDown(this.videoID);
			},
		},
		components:{
			Intersect
		},
		beforeMount: function(){
			if(this.previewType=='video'){
				this.$root.subVotesForVideo(this.videoID);
			}
		},
		beforeDestroy: function(){
			if(this.previewType=='video'){
				this.$root.unsubVotesForVideo(this.videoID);
			}
		}
		
	}
</script>
<style lang="less">
	.videoPlayer{
		background-color:white;
		margin-bottom: 25px;
		&.shadow{
			box-shadow: 0 3px 15px rgba(0,0,0,.31);
			&:hover{
				box-shadow: 0 3px 15px rgba(0,0,0,.60);
			}
		}

		.cont169{
			padding-bottom:calc(100%* 9 / 16);
			background-color: black;
			display: block;
			position: relative;
			iframe{
				position:absolute;
				width:100% !important;
				height:100% !important;
				top:0;
				left:0;
			}
			.imageCont{
				position:absolute;
				height:100% !important;
				top:0;
				left:0;
				height:100%;
				width:100%;
				.youtubeThumb{
					display: block;
					margin-left: auto;
					margin-right: auto;
					height:100%;
				}
			}
		}
		.voteCont{
			display:block;
			display: flex;
			// padding-top: 10px;
			// padding-bottom: 10px;
			padding-left: 15px;
			padding-right: 15px;
			box-sizing: border-box;
			flex-direction: row;
			flex-wrap: nowrap;
			justify-content: flex-end;
			align-items: center;
			line-height: 52px;
			.voteUp{
				background:white;
				border: none !important;
				padding: 5px;
				margin: 5px;
				font-size: 18px;
				padding-left: 10px;
				padding-right: 10px;
				cursor:pointer;
				&:hover{
					color:green;
					background:rgba(0,0,0,.15);
				}
			}
			.voteDown{
				background:white;
				border: none !important;
				padding: 5px;
				margin: 5px;
				cursor:pointer;
				font-size: 18px;
				padding-left: 10px;
				padding-right: 10px;
				&:hover{
					color:green;
					background:rgba(0,0,0,.15);
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// videoPlayer.vue?05d5e14b